import { UserIcon, TrashIcon } from "@heroicons/react/24/outline";
import Modal from "../../ui-components/Modal";

export function sharingInfoModal(
  showSharing,
  setShowSharing,
  removeSharing,
  intl
) {
  return (
    <Modal onExit={() => setShowSharing(false)}>
      <div className="flex w-full flex-col h-full">
        <label className="block text-lg font-bold mb-5">
          {intl.formatMessage({ id: "shared_users" })}
        </label>
        {(showSharing || []).map((user, n) => (
          <div key={n} className="grid grid-cols-5 my-4">
            <div
              className={"text-center" + (removeSharing ? " text-red-500" : "")}
            >
              {removeSharing ? (
                <TrashIcon
                  className="mt-3 h-5 w-5 inline-block cursor-pointer"
                  aria-hidden="true"
                  onClick={() => {
                    removeSharing(user);
                  }}
                />
              ) : (
                <UserIcon
                  className="mt-3 h-5 w-5 inline-block"
                  aria-hidden="true"
                />
              )}
            </div>
            <div className="col-span-4">
              <span>
                {user.firstname} {user.lastname}{" "}
              </span>
              <br />
              <span className="italic text-sm">
                {intl.formatMessage({ id: user.account_user?.role?.name || user.role.name })}
              </span>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
}
